<template lang="pug">
.page-home-mapinfo
  .page-home-mapinfo-embed(v-html="informations.local_embed")
  .page-home-mapinfo-content.pb-6.pt-7.px-8
    .white--text
      .mb-6.d-flex.align-center(
        v-for="({ title, link, icon }, i) in contact",
        :key="i"
      )
        v-btn.mr-2(:href="link", target="_blank", color="white", icon)
          v-icon(size="24px") {{ icon }}
        .text-body-1
          span.ubuntu {{ title }}
    grid-container.justify-end(auto-flow="column", gap="20px")
      tooltip(v-for="(s, i) in social", :key="i", :tip="s.title", bottom)
        v-btn(
          :href="s.link",
          target="_blank",
          fab,
          depressed,
          height="48px",
          width="48px"
        )
          v-icon(color="#0077A0") {{ s.icon }}
</template>

<script>
import Tooltip from "@/components/tools/Tooltip";

import { getWhatsappLinkFromPhone } from "@/components/utils.js";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contact() {
      return [
        {
          title: this.informations.local_text,
          link: this.informations.local_link,
          icon: "fas fa-map-marker-alt",
        },
        {
          title: this.informations.whatsapp,
          link: getWhatsappLinkFromPhone(this.informations.whatsapp || ""),
          icon: "fab fa-whatsapp",
        },
        {
          title: this.informations.email,
          link: "mailto:" + this.informations.email,
          icon: "fas fa-envelope",
        },
      ];
    },
    social() {
      return [
        {
          title: "Facebook",
          link: this.informations.facebook,
          icon: "fab fa-facebook-f",
        },
        {
          title: "Instagram",
          link: this.informations.instagram,
          icon: "fab fa-instagram",
        },
      ];
    },
  },
  components: {
    Tooltip,
  },
};
</script>

<style>
.page-home-mapinfo {
  position: relative;
}

.page-home-mapinfo-embed iframe {
  width: 100%;
  aspect-ratio: 1440 / 443;
  margin-bottom: -6px;
}

.page-home-mapinfo-content {
  position: absolute;
  right: 135px;
  bottom: 69px;
  background: rgba(0, 119, 160, 0.8);
  backdrop-filter: blur(4px);
  max-width: 448px;
  border-radius: 8px;
}

@media screen and (max-width: 1264px) {
  .page-home-mapinfo-embed iframe {
    aspect-ratio: 2;
  }

  .page-home-mapinfo-content {
    right: 24px !important;
    bottom: 24px !important;
  }
}

@media screen and (max-width: 960px) {
  .page-home-mapinfo-embed iframe {
    aspect-ratio: 1.5;
  }
}

@media screen and (max-width: 600px) {
  .page-home-mapinfo-embed iframe {
    aspect-ratio: 1;
  }

  .page-home-mapinfo-content {
    width: 100%;
    position: static;
    border-radius: 0px !important;
  }
}
</style>
